import {useFormik} from 'formik';
import * as Yup from 'yup';
import {AxiosError} from 'axios';
import {CreateCategoryGroupDTO, useCategoryGroups} from '../../../entities';
import {useSchemes} from '../../../shared';

interface UseAddCategoryGroupFormProps {
  setOpen: (open: boolean) => void;
}

export const useAddCategoryGroupForm = ({setOpen}: UseAddCategoryGroupFormProps) => {
  const {createCategoryGroupMutation} = useCategoryGroups();
  const {nameSchema, orderSchema} = useSchemes();

  const onSubmit = async (values: CreateCategoryGroupDTO) => {
    try {
      await createCategoryGroupMutation.mutateAsync({
        ...values,
        imageUploadId: values.imageUploadId || null,
      });
      setOpen(false);
    } catch (error: any) {
      console.error(error);
    }
  };

  const formik = useFormik<CreateCategoryGroupDTO>({
    initialValues: {
      name: '',
      order: 0,
      imageUploadId: null,
    },
    validationSchema: Yup.object({
      name: nameSchema,
      order: orderSchema,
      imageUploadId: Yup.string().nullable(),
    }),
    onSubmit,
  });

  return {
    values: formik.values,
    errors: formik.errors,
    touched: formik.touched,
    setFieldValue: formik.setFieldValue,
    setFieldTouched: formik.setFieldTouched,
    handleChange: formik.handleChange,
    handleBlur: formik.handleBlur,
    resetForm: formik.resetForm,
    submitForm: formik.submitForm,
    isLoading: createCategoryGroupMutation.isPending,
    submitError: createCategoryGroupMutation.error
      ? (createCategoryGroupMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
  };
};
